import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
  Divider,
  alpha
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import StarIcon from '@mui/icons-material/Star';
import VideocamIcon from '@mui/icons-material/Videocam';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LinkIcon from '@mui/icons-material/Link';
import FolderIcon from '@mui/icons-material/Folder';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountTreeIcon from '@mui/icons-material/AccountTree'; // For Zoho CRM
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'; // For Pipedrive
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'; // For about.me
import GroupIcon from '@mui/icons-material/Group'; // For teamup
import YouTubeIcon from '@mui/icons-material/YouTube'; // For YouTube Premium
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'; // For Vimeo

const CreatorProPopup = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const features = [
    { icon: <PersonIcon />, title: 'Bio / Profile Page', description: 'Photo, Contact Details, and more' },
    { icon: <GroupsIcon />, title: 'CRM / Workflows', description: 'Subscriber / Prospect / Client Management' },
    { icon: <StarIcon />, title: 'Reviews', description: 'Collect & showcase testimonials' },
    { icon: <VideocamIcon />, title: 'Video Hub', description: 'Host & share your content' },
    { icon: <CalendarTodayIcon />, title: 'Calendar / Meetings', description: 'Book and manage meetings easily' },
    { icon: <EventAvailableIcon />, title: 'Community / Community Calendar', description: 'Sync schedules & meetings' },
    { icon: <LinkIcon />, title: 'Link Hub', description: 'All your links in one place' },
    { icon: <FolderIcon />, title: 'File Storage', description: 'Secure cloud storage' },
    { icon: <PhotoLibraryIcon />, title: 'Recent Work', description: 'Photos, Locations, Content' }
  ];

//   const otherTools = [
//     { name: 'Calendly', price: '$10/mo' },
//     { name: 'Zoho CRM', price: '$24/mo' },
//     { name: 'Pipedrive', price: '$14/mo' },
//     { name: 'about.me', price: '$9/mo' },
//     { name: 'Linktree', price: '$8/mo' },
//     { name: 'teamup', price: '$12/mo' },
//     { name: 'YouTube Premium', price: '$14/mo' },
//     { name: 'Vimeo', price: '$12/mo' },
//     { name: 'Dropbox', price: '$12/mo' }
//   ];
// const otherTools = [
//   { 
//     name: 'Calendly', 
//     price: '$10/mo',
//     icon: <CalendarTodayIcon sx={{ fontSize: 16 }} />
//   },
//   { 
//     name: 'Zoho CRM', 
//     price: '$24/mo',
//     icon: <AccountTreeIcon sx={{ fontSize: 16 }} />
//   },
//   { 
//     name: 'Pipedrive', 
//     price: '$14/mo',
//     icon: <AccountBalanceIcon sx={{ fontSize: 16 }} />
//   },
//   { 
//     name: 'about.me', 
//     price: '$9/mo',
//     icon: <PersonOutlineIcon sx={{ fontSize: 16 }} />
//   },
//   { 
//     name: 'Linktree', 
//     price: '$8/mo',
//     icon: <LinkIcon sx={{ fontSize: 16 }} />
//   },
//   { 
//     name: 'teamup', 
//     price: '$12/mo',
//     icon: <GroupIcon sx={{ fontSize: 16 }} />
//   },
//   { 
//     name: 'YouTube Premium', 
//     price: '$14/mo',
//     icon: <YouTubeIcon sx={{ fontSize: 16 }} />
//   },
//   { 
//     name: 'Vimeo', 
//     price: '$12/mo',
//     icon: <OndemandVideoIcon sx={{ fontSize: 16 }} />
//   },
//   { 
//     name: 'Dropbox', 
//     price: '$12/mo',
//     // icon: <CloudIcon sx={{ fontSize: 16 }} />
//   }
// ];
// Remove the icon imports for these tools from MUI icons
// Keep only the imports you need for other parts

// Update your otherTools array to use image paths:
const otherTools = [
  { 
    name: 'Calendly', 
    price: '$10/mo',
    logo: '/logo/calendly_logo-removebg-preview.png'  // Update with your actual path
  },
  { 
    name: 'Zoho CRM', 
    price: '$24/mo',
    logo: '/logo/ZOHO_logo_2023.svg.png'
  },
  { 
    name: 'Pipedrive', 
    price: '$14/mo',
    logo: '/logo/pipedrive-removebg-preview.png'
  },
  { 
    name: 'about.me', 
    price: '$9/mo',
    logo: '/logo/about_me-removebg-preview.png'
  },
  { 
    name: 'Linktree', 
    price: '$8/mo',
    logo: '/logo/linktree-removebg-preview.png'
  },
  { 
    name: 'teamup', 
    price: '$12/mo',
    logo: '/logo/teamup-removebg-preview.png'
  },
  { 
    name: 'YouTube Premium', 
    price: '$14/mo',
    logo: '/logo/new-youtube-premium-features-1280-6d58ec9cf9-removebg-preview.png'
  },
  { 
    name: 'Vimeo', 
    price: '$12/mo',
    logo: '/logo/Vimeo-Logo.png'
  },
  { 
    name: 'Dropbox', 
    price: '$12/mo',
    logo: '/logo/dropbox-removebg-preview.png'
  }
];

  const creatorProTools = [
    'Scheduling',
    'CRM',
    'Workflows',
    'Bio Page',
    'Link Hub',
    'Team Calendar',
    'Video',
    'Video Hosting',
    'File Storage'
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: '#0a0a0a',
          borderRadius: 2,
          maxHeight: '90vh',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }
      }}
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(8px)',
          bgcolor: 'rgba(0, 0, 0, 0.8)'
        }
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          color: 'white',
          width: 40,
          height: 40,
          zIndex: 10,
          '&:hover': {
            bgcolor: 'rgba(255, 255, 255, 0.2)'
          }
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0, overflowY: 'auto', maxHeight: '90vh' }}>
        <Container sx={{ py: 6, px: { xs: 3, md: 6 } }}>
          {/* Header */}
          <Box textAlign="center" mb={6}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: alpha('#27a147', 0.2),
                border: '1px solid rgba(39, 161, 71, 0.4)',
                borderRadius: 9999,
                px: 2,
                py: 1,
                mb: 3
              }}
            >
              <Typography
                sx={{
                  color: '#27a147',
                  fontWeight: 'bold',
                  fontSize: 18
                }}
              >
                Creator PRO
              </Typography>
            </Box>
             <Typography
              variant="h4"
              sx={{
                // fontSize: { xs: '1.75rem', md: '3rem' },
                fontWeight: 'bold',
                mb: 3,
                color: 'white',
                lineHeight: 1.2
              }}
            >
             Coming Soon
            </Typography>

            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: '1.75rem', md: '2rem' },
                fontWeight: 'bold',
                mb: 3,
                color: 'white',
                lineHeight: 1.2
              }}
            >
              Work Smarter. <Box component="span" sx={{ color: '#27a147' }}>One Platform</Box>
              <br />
              That Replaces Them All.
            </Typography>

            <Typography
              sx={{
                fontSize: 18,
                color: '#9ca3af',
                mb: 4,
                maxWidth: 640,
                mx: 'auto'
              }}
            >
              Stop paying for a stack of tools that barely talk to each other. Creator PRO replaces your scheduler, CRM, links, files, and workflows—all in one place.
            </Typography>
          </Box>
  <Box
            sx={{
              background: 'linear-gradient(135deg, rgba(39, 161, 71, 0.2), rgba(39, 161, 71, 0.05))',
              border: '1px solid rgba(39, 161, 71, 0.3)',
              borderRadius: 1.5,
              p: 4,
              maxWidth: 600,
              mx: 'auto',
              mb:3
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <AccessTimeIcon sx={{ fontSize: 32, color: '#27a147' }} />
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'white' }}>
                All on Your Own Domain
              </Typography>
            </Box>

            <Typography sx={{ color: '#d1d5db', mb: 3 }}>
              Your Creator PRO system will be deployed instantly as:
            </Typography>

            <Box
              sx={{
                bgcolor: 'rgba(0, 0, 0, 0.4)',
                borderRadius: 1,
                p: 1.5,
                mb: 2,
                fontFamily: 'monospace',
                color: '#27a147',
                fontSize: 18,
                textAlign:"center"
              }}
            >
              Username.1house.page
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, color: '#9ca3af' }}>
              <CheckCircleIcon sx={{ fontSize: 20, color: '#27a147', flexShrink: 0, mt: 0.25 }} />
              <Typography variant="body2">
                Add your own custom domain at no additional charge — live worldwide in under an hour
              </Typography>
            </Box>
          </Box>
          {/* Features Grid */}
          <Grid container spacing={2} mb={6}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: 1.5,
                    p: 2.5,
                    height: '100%',
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: 'rgba(39, 161, 71, 0.5)',
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                      transform: 'scale(1.02)'
                    }
                  }}
                >
                  <Box sx={{ color: '#27a147', mb: 1.5, '& svg': { fontSize: 32 } }}>
                    {feature.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#9ca3af' }}>
                    {feature.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Comparison Grid */}
          <Grid container spacing={3} mb={6}>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  bgcolor: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: 1.5,
                  p: 3,
                  height: '100%'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3
                  }}
                >
                  <Typography variant="h6" sx={{ color: '#9ca3af' }}>
                    Other Tools
                  </Typography>
                  <Typography sx={{ color: '#f87171', fontWeight: 'bold', fontSize: 20 }}>
                    $115/mo
                  </Typography>
                </Box>

                {/* {otherTools.map((tool, index) => (
                  <React.Fragment key={index}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        py: 1,
                        borderBottom: index < otherTools.length - 1 ? '1px solid rgba(255, 255, 255, 0.05)' : 'none'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <CancelIcon sx={{ fontSize: 16, color: '#f87171' }} />
                        <Typography variant="body2" sx={{ color: '#d1d5db' }}>
                          {tool.name}
                        </Typography>
                      </Box>
                      <Typography variant="body2" sx={{ color: '#6b7280' }}>
                        {tool.price}
                      </Typography>
                    </Box>
                  </React.Fragment>
                ))} */}
               {otherTools.map((tool, index) => (
  <React.Fragment key={index}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 1.5,  // Increased padding for better alignment
        borderBottom: index < otherTools.length - 1 ? '1px solid rgba(255, 255, 255, 0.05)' : 'none'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <CancelIcon sx={{ fontSize: 16, color: '#f87171' }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Logo Image */}
          <Box
            component="img"
            src={tool.logo}
            alt={tool.name}
            sx={{
              width: 60,
              height: 30,
              
            //   objectFit: 'contain',
            //   opacity: 0.9
            }}
          />
          {/* <Typography variant="body2" sx={{ color: '#d1d5db' }}>
            {tool.name}
          </Typography> */}
        </Box>
      </Box>
      <Typography variant="body2" sx={{ color: '#6b7280' }}>
        {tool.price}
      </Typography>
    </Box>
  </React.Fragment>
))}
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  background: 'linear-gradient(135deg, rgba(39, 161, 71, 0.2), rgba(39, 161, 71, 0.05))',
                  border: '1px solid rgba(39, 161, 71, 0.3)',
                  borderRadius: 1.5,
                  p: 3,
                  height: '100%'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3
                  }}
                >
                  <Typography variant="h6" sx={{ color: '#27a147' }}>
                    Creator PRO
                  </Typography>
                  <Typography sx={{ color: '#27a147', fontWeight: 'bold', fontSize: 20 }}>
                    Included
                  </Typography>
                </Box>

                {creatorProTools.map((tool, index) => (
                  <React.Fragment key={index}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        py: 1,
                        borderBottom: index < creatorProTools.length - 1 ? '1px solid rgba(255, 255, 255, 0.05)' : 'none'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <CheckCircleIcon sx={{ fontSize: 16, color: '#27a147' }} />
                        <Typography variant="body2" sx={{ color: '#d1d5db' }}>
                          {tool}
                        </Typography>
                      </Box>
                    </Box>
                  </React.Fragment>
                ))}

                <Divider sx={{ borderColor: 'rgba(39, 161, 71, 0.3)', mt: 6, mb: 2 }} />

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pt: 2
                  }}
                >
                  <Typography variant="body2" sx={{ color: '#d1d5db' }}>
                    You save
                  </Typography>
                  <Typography sx={{ color: '#27a147', fontWeight: 'bold', fontSize: 20 }}>
                    $115/mo or more
                  </Typography>
                </Box>
              </Card>
            </Grid>
          </Grid>

          {/* Domain Card */}
        
        </Container>
      </DialogContent>
    </Dialog>
  );
};

export default CreatorProPopup;